import { Case } from '@/entities/cases'
import { useStyles } from './styles'
import CaseCard from '@/features/cardCase'

type CaseListProps = {
  data: Case[]
  sortBy?: 'id' | 'name' | 'idreverse' | 'isactive' | 'isactiveidreverse'
}

export const CaseList = (props: CaseListProps) => {
  const { data: cases } = props
  const { classes } = useStyles()
  const sortedCases = [...cases].sort((a, b) => {
    return a.position - b.position
  })

  return (
    <div className={classes.root}>
      {sortedCases.map((item) => (
        <CaseCard {...item} key={item.id} />
      ))}
    </div>
  )
}
